/**
 * Created by Rakesh Peela
 * Date: 01-Jan-2020
 * Time: 2:36 PM
 */

export const ORIENTATION_ENUM = {
    PORTRAIT: "portrait",
    LANDSCAPE: "landscape"
};